import OldUploadFile from './OldUploadFile.vue';

OldUploadFile.install = (Vue) => {
  Vue.component(OldUploadFile.name, OldUploadFile);
};

export default OldUploadFile;
